import { CMCD_EVENT_KEYS } from './CMCD_EVENT_KEYS.ts'
import { CMCD_REQUEST_KEYS } from './CMCD_REQUEST_KEYS.ts'
import { CMCD_RESPONSE_KEYS } from './CMCD_RESPONSE_KEYS.ts'
import { CMCD_V1_KEYS } from './CMCD_V1_KEYS.ts'
import type { CmcdKey } from './CmcdKey.ts'

/**
 * A list of all CMCD keys.
 *
 * @public
 */
export const CMCD_KEYS: CmcdKey[] = /* @__PURE__ */ [
	...CMCD_V1_KEYS,
	...CMCD_REQUEST_KEYS,
	...CMCD_RESPONSE_KEYS,
	...CMCD_EVENT_KEYS,
].filter((key, index, arr) => arr.indexOf(key) === index)
